import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Import pages
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import OurHomes from "./pages/OurHomes";
import OurChallenges from "./pages/OurChallenges";
import HowYouCanHelp from "./pages/HowYouCanHelp";
import Activities from "./pages/Activities";
import Gallery from "./pages/Gallery";
import Volunteers from "./pages/Volunteers";
import ContactUs from "./pages/ContactUs";
import AddActivity from './pages/admin/AddActivity';
function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/our-homes" element={<OurHomes />} />
        <Route path="/our-challenges" element={<OurChallenges />} />
        <Route path="/how-you-can-help" element={<HowYouCanHelp />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/volunteers" element={<Volunteers />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/admin/add-activity" element={<AddActivity />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;